module.exports = __webpack_public_path__ + "static/img/gongdi.e7871fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/AboutUs/gongdi.png
// module id = Ijfi
// module chunks = 12